/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseLinkField
 */
export interface DatabaseLinkField extends DatabaseField {
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseLinkField
     */
    underlined?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabaseLinkField
     */
    color?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseLinkField
     */
    hasLink?: boolean;
    /**
     * Vorbelegung des Link-Feldes. Beim Anlegen eines Eintrags wird sie als
     * Feldwert gesetzt, sofern der Eintrag keinen eigenen Wert hat — so
     * bekommt jeder Eintrag automatisch denselben Link (z.B. den
     * WBT-Zugangslink). Platzhalter, auch in manuell gesetzten Werten:
     *   {dbId}   = Kennung dieser Datenbank
     *   {apiEnv} = Umgebung dieses Backends ("dev" oder "prod"), damit
     *              dieselbe Vorlage in beiden Umgebungen funktioniert,
     *              z. B. .../index.html?db={dbId}&api={apiEnv}
     * @type {string}
     * @memberof DatabaseLinkField
     */
    urlTemplate?: string;
}

/**
 * Check if a given object implements the DatabaseLinkField interface.
 */
export function instanceOfDatabaseLinkField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseLinkFieldFromJSON(json: any): DatabaseLinkField {
    return DatabaseLinkFieldFromJSONTyped(json, false);
}

export function DatabaseLinkFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseLinkField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'underlined': !exists(json, 'underlined') ? undefined : json['underlined'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'hasLink': !exists(json, 'hasLink') ? undefined : json['hasLink'],
        'urlTemplate': !exists(json, 'urlTemplate') ? undefined : json['urlTemplate'],
    };
}

export function DatabaseLinkFieldToJSON(value?: DatabaseLinkField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'underlined': value.underlined,
        'color': value.color,
        'hasLink': value.hasLink,
        'urlTemplate': value.urlTemplate,
    };
}

